import { render, staticRenderFns } from "./GoalsLibrary.vue?vue&type=template&id=7c128c1f&scoped=true"
import script from "./GoalsLibrary.vue?vue&type=script&lang=js"
export * from "./GoalsLibrary.vue?vue&type=script&lang=js"
import style0 from "./GoalsLibrary.vue?vue&type=style&index=0&id=7c128c1f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c128c1f",
  null
  
)

export default component.exports